// Client-side image processing: resize to max 1600px long edge, JPEG 0.78,
// EXIF-orientation aware, target under 500KB, log before/after.

const MAX_EDGE = 1600;
const TARGET_KB = 500;
const START_Q = 0.78;
const MIN_Q = 0.4;

function base64Bytes(dataUrl) {
  const idx = dataUrl.indexOf(",");
  const b64 = dataUrl.slice(idx + 1);
  return Math.floor((b64.length * 3) / 4);
}

async function decodeBitmap(file) {
  // createImageBitmap with imageOrientation: 'from-image' handles EXIF rotation.
  // Not all browsers support the option — fall back to plain decode + <img> path if needed.
  try {
    return await createImageBitmap(file, { imageOrientation: "from-image" });
  } catch (_) {
    // Fallback: use <img> tag (browser auto-applies EXIF on img decode in modern engines).
    return await new Promise((resolve, reject) => {
      const url = URL.createObjectURL(file);
      const img = new Image();
      img.onload = () => {
        URL.revokeObjectURL(url);
        resolve(img);
      };
      img.onerror = (e) => {
        URL.revokeObjectURL(url);
        reject(e);
      };
      img.src = url;
    });
  }
}

function drawToCanvas(source, w, h) {
  const canvas = document.createElement("canvas");
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext("2d");
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = "high";
  ctx.drawImage(source, 0, 0, w, h);
  return canvas;
}

export async function processImageToBase64(file) {
  const origBytes = file.size;
  const src = await decodeBitmap(file);
  const w0 = src.width || src.naturalWidth;
  const h0 = src.height || src.naturalHeight;

  const scale = Math.min(1, MAX_EDGE / Math.max(w0, h0));
  let w = Math.round(w0 * scale);
  let h = Math.round(h0 * scale);

  let canvas = drawToCanvas(src, w, h);
  let quality = START_Q;
  let dataUrl = canvas.toDataURL("image/jpeg", quality);
  let size = base64Bytes(dataUrl);

  // First, walk quality down
  while (size > TARGET_KB * 1024 && quality > MIN_Q) {
    quality = Math.max(MIN_Q, quality - 0.08);
    dataUrl = canvas.toDataURL("image/jpeg", quality);
    size = base64Bytes(dataUrl);
  }

  // If still too big, downscale further and start again
  let attempts = 0;
  while (size > TARGET_KB * 1024 && attempts < 3) {
    w = Math.round(w * 0.8);
    h = Math.round(h * 0.8);
    canvas = drawToCanvas(canvas, w, h);
    quality = 0.7;
    dataUrl = canvas.toDataURL("image/jpeg", quality);
    size = base64Bytes(dataUrl);
    attempts++;
  }

  // eslint-disable-next-line no-console
  console.log(
    `[glenlyon:photo] original=${(origBytes / 1024).toFixed(0)}KB (${w0}x${h0}) → resized=${(size / 1024).toFixed(0)}KB @ ${w}x${h}, q=${quality.toFixed(2)}`,
  );

  return dataUrl;
}
